import React from "react";

export default function CompanyFormsEmptyState({
  icon: Icon,
  title,
  description,
  children,
}) {
  return (
    <div className="rounded-xl border border-[#E5ECF5] bg-white px-5 py-10 text-center shadow-[0_1px_2px_rgba(20,33,61,0.05)]">
      {Icon ? (
        <div className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-lg bg-[#EFF6FF] text-[#007BFF]">
          <Icon size={20} strokeWidth={1.75} aria-hidden />
        </div>
      ) : null}
      <p className="m-0 text-sm font-semibold text-[#14213D]">{title}</p>
      {description ? (
        <p className="mx-auto mt-1.5 max-w-md text-xs leading-relaxed text-[#64748B]">
          {description}
        </p>
      ) : null}
      {children ? <div className="mt-4">{children}</div> : null}
    </div>
  );
}
